import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  dataSets: Record<string, unknown>; // Sử dụng unknown type cho dataSets
}

const initialState: UserState = {
  dataSets: {},
};

export const userSlice = createSlice({
  name: "commomData",
  initialState,
  reducers: {
    saveData: (
      state,
      action: PayloadAction<{ dataSetName: string; data: unknown }>
    ) => {
      const { dataSetName, data } = action.payload;
      state.dataSets[dataSetName] = data;
    },
    clearData: (state, action: PayloadAction<string>) => {
      const dataSetName = action.payload;
      delete state.dataSets[dataSetName];
    },
  },
});

export const { saveData, clearData } = userSlice.actions;

export default userSlice.reducer;
